import { plugin, Mode } from 'light-component';
import { useTranslation } from '../../../i18n';
import { Thumbnail } from '../../component';
import { WidgetType } from '../types';
import { ShotEyesGridInputMode } from './input';
import { ShotEyesGridDesignMode } from './design';
import { ShotEyesGridViewMode } from './view';
import type { ReactElement } from 'react';
import type { ShotEyesGridProps } from './types';

// 问卷-表格
export function QuestionnaireTable(props: ShotEyesGridProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='ShotEyesGridIcon' title={t('ShotEyesGrid')} toolTipContent={t('表格填写')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<ShotEyesGridDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<ShotEyesGridViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<ShotEyesGridInputMode {...props} />);
  }

  return null;
}

QuestionnaireTable.prototype.type = WidgetType.SHOTEYES_GRID;
plugin.register({ kind: 'widget', component: QuestionnaireTable });
